module.exports = __webpack_public_path__ + "static/media/loadIcon.fd65fed4.svg";